import { createRoot } from "react-dom/client";
import { FormProvider } from "./contexts/FormContext";
import { ModalProvider } from "./contexts/ModalContext";
import App from "./pages/App";
import Blog from "./pages/Blog";
import PoliticaPrivacidade from "./pages/PoliticaPrivacidade";

import { BrowserRouter, Route, Routes } from "react-router";
import Menu from "./components/menu";
import Contato from "./components/contato";

import ArtigoPage from "./pages/ArtigoPage";
import QuemSomos from "./pages/QuemSomos";
import Development from "./pages/projects/Development";
import GestaoMudanca from "./pages/projects/GestaoMudanca";
import Pmo from "./pages/projects/Pmo";
import Projects from "./pages/projects/Projects";
import RecuperacaoProjetos from "./pages/projects/RecuperacaoProjetos";
import SoftwareDevelopment from "./pages/projects/SoftwareDevelopment";

import Ato from "./pages/projects/ATO";
import BusinessAgility from "./pages/projects/BusinessAgility";
import DevSolucoes from "./pages/projects/DevSolucoes";
import EscopoFechado from "./pages/projects/EscopoFechado";
import GestaoPortfolio from "./pages/projects/GestaoPortfolio";
import NewTechs from "./pages/projects/NewTechs";
import Smartsourcing from "./pages/projects/Smartsourcing";
import Squad from "./pages/projects/Squad";

import Intelligence from "./pages/innovation/Intelligence";
import Data from "./pages/innovation/Data";

import Cloud from "./pages/innovation/Cloud";
import Devops from "./pages/innovation/Devops";
import Finops from "./pages/innovation/Finops";
import Migracao from "./pages/innovation/Migracao";
import Monitoramento from "./pages/innovation/monitoramento";

import Innovation from "./pages/innovation/Innovation";
import Seguranca from "./pages/innovation/Seguranca";
import Finep from "./pages/innovation/Finep";
import Ia from "./pages/innovation/Ia";

import Advisor from "./pages/solutions/Advisor";
import Ams from "./pages/solutions/Ams";
import Erp from "./pages/solutions/Erp";
import ErpExpertise from "./pages/solutions/ErpExpertise";
import Omnifactory from "./pages/solutions/Omnifactory";
import SmartsourcingErp from "./pages/solutions/SmartsourcingErp";
import Solutions from "./pages/solutions/Solutions";

createRoot(document.getElementById("root")).render(
  <BrowserRouter>
    <FormProvider>
      <ModalProvider>
        <Menu />      
        <Contato />
        
        <Routes>
          <Route path="/" element={<App />} />
          <Route path="/artigo" element={<ArtigoPage />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/politicadeprivacidade" element={<PoliticaPrivacidade />} />
          <Route path="/quem-somos" element={<QuemSomos />} />

          <Route path="/projects" element={<Projects />} />
          <Route path="/business-agility" element={<BusinessAgility />} />
          <Route path="/pmo" element={<Pmo />} />
          <Route path="/ato" element={<Ato />} />
          <Route path="/gestao-de-portfolio" element={<GestaoPortfolio />} />
          <Route path="/gestao-de-mudancas" element={<GestaoMudanca />} />

          <Route path="/development" element={<Development />} />
          <Route path="/desenvolvimento-de-softwares" element={<SoftwareDevelopment />} />
          <Route path="/desenvolvimento-de-solucoes" element={<DevSolucoes />} />
          <Route path="/recuperacao-de-projetos" element={<RecuperacaoProjetos />} />
          <Route path="/programa-new-techs" element={<NewTechs />} />
          <Route path="/squad" element={<Squad />} />
          <Route path="/escopo-fechado" element={<EscopoFechado />} />
          <Route path="/smartsourcing" element={<Smartsourcing />} />

          <Route path="/intelligence" element={<Intelligence />} />
          <Route path="/ia" element={<Ia />} />
          <Route path="/data" element={<Data />} />
          <Route path="/finep" element={<Finep />} />

          <Route path="/innovation" element={<Innovation />} />
          <Route path="/cloud" element={<Cloud />} />
          <Route path="/devops" element={<Devops />} />
          <Route path="/finops" element={<Finops />} />
          <Route path="/migracao" element={<Migracao />} />
          <Route path="/seguranca" element={<Seguranca />} />
          <Route path="/monitoramento" element={<Monitoramento />} />

          <Route path="/solutions" element={<Solutions />} />
          <Route path="/erp" element={<Erp />} />
          <Route path="/erp-expertise" element={<ErpExpertise />} />
          <Route path="/advisor" element={<Advisor />} />
          <Route path="/ams" element={<Ams />} />
          <Route path="/erp-smartsourcing" element={<SmartsourcingErp />} />
          <Route path="/omnifactory" element={<Omnifactory />} />
        </Routes>
      </ModalProvider>
    </FormProvider>
  </BrowserRouter>
);
